/**
 * @generated SignedSource<<25e904ae5b775ca81c3432d8b88c4f87>>
 * @relayHash 699be9b81fc7f2d8a2bc6b02126e9e7f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bacba6f59f512b80b185bd9f1146c403ef66211c7d7ea7aa288d0cd5991e41cf

import type { ConcreteRequest } from 'relay-runtime';
export type useBlogPostsQueryQuery$variables = {
  cql: string;
  first?: number | null | undefined;
  includeAdfBody: boolean;
  includeAdfExcerpt: boolean;
  includeExcerpt: boolean;
  includeRenderedBody: boolean;
  includeRenderedExcerpt: boolean;
};
export type useBlogPostsQueryQuery$data = {
  readonly search: {
    readonly count: number | null | undefined;
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly body: {
          readonly atlas_doc_format?: {
            readonly value: string | null | undefined;
          } | null | undefined;
          readonly view?: {
            readonly value: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly excerpt?: string;
        readonly history: {
          readonly createdBy: {
            readonly accountId?: string | null | undefined;
            readonly displayName?: string | null | undefined;
            readonly profilePicture?: {
              readonly path: string;
            } | null | undefined;
          } | null | undefined;
          readonly createdDate: string | null | undefined;
          readonly lastUpdated: {
            readonly when: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly id: string | null | undefined;
        readonly labels: {
          readonly nodes: ReadonlyArray<{
            readonly name: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly links: {
          readonly base: string | null | undefined;
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly macroExcerpt?: {
          readonly atlasDocFormat?: string | null | undefined;
          readonly view?: string | null | undefined;
        } | null | undefined;
        readonly space: {
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useBlogPostsQueryQuery = {
  response: useBlogPostsQueryQuery$data;
  variables: useBlogPostsQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cql"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAdfBody"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAdfExcerpt"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeExcerpt"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeRenderedBody"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeRenderedExcerpt"
},
v7 = [
  {
    "kind": "Variable",
    "name": "cql",
    "variableName": "cql"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "count"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "title"
},
v11 = {
  "kind": "ScalarField",
  "name": "type"
},
v12 = [
  {
    "kind": "Literal",
    "name": "fallbackToBody",
    "value": false
  }
],
v13 = {
  "condition": "includeExcerpt",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "length",
          "value": 500
        }
      ],
      "kind": "ScalarField",
      "name": "excerpt",
      "storageKey": "excerpt(length:500)"
    },
    {
      "concreteType": "ConfluenceMacroExcerptBody",
      "kind": "LinkedField",
      "name": "macroExcerpt",
      "plural": false,
      "selections": [
        {
          "condition": "includeRenderedExcerpt",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": (v12/*: any*/),
              "kind": "ScalarField",
              "name": "view",
              "storageKey": "view(fallbackToBody:false)"
            }
          ]
        },
        {
          "condition": "includeAdfExcerpt",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": (v12/*: any*/),
              "kind": "ScalarField",
              "name": "atlasDocFormat",
              "storageKey": "atlasDocFormat(fallbackToBody:false)"
            }
          ]
        }
      ]
    }
  ]
},
v14 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v15 = {
  "concreteType": "ContentBodyPerRepresentation",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "condition": "includeRenderedBody",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "ContentBody",
          "kind": "LinkedField",
          "name": "view",
          "plural": false,
          "selections": (v14/*: any*/)
        }
      ]
    },
    {
      "condition": "includeAdfBody",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "ContentBody",
          "kind": "LinkedField",
          "name": "atlas_doc_format",
          "plural": false,
          "selections": (v14/*: any*/)
        }
      ]
    }
  ]
},
v16 = {
  "kind": "ScalarField",
  "name": "name"
},
v17 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    },
    {
      "kind": "ScalarField",
      "name": "base"
    }
  ]
},
v18 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "ScalarField",
      "name": "key"
    },
    (v16/*: any*/)
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v20 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    },
    (v19/*: any*/),
    (v20/*: any*/)
  ],
  "type": "KnownUser"
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    (v19/*: any*/),
    (v20/*: any*/)
  ],
  "type": "UnknownUser"
},
v23 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v24 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "lastUpdated",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "when"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useBlogPostsQueryQuery",
    "selections": [
      {
        "alias": "search",
        "args": (v7/*: any*/),
        "concreteType": "ConfluenceSearchConnection",
        "kind": "LinkedField",
        "name": "confluence_search",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "concreteType": "ConfluenceSearchResponse",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v15/*: any*/),
                  {
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v16/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v22/*: any*/)
                        ]
                      },
                      (v23/*: any*/),
                      (v24/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "useBlogPostsQueryQuery",
    "selections": [
      {
        "alias": "search",
        "args": (v7/*: any*/),
        "concreteType": "ConfluenceSearchConnection",
        "kind": "LinkedField",
        "name": "confluence_search",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "concreteType": "ConfluenceSearchResponse",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v15/*: any*/),
                  {
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v16/*: any*/),
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v21/*: any*/),
                          (v22/*: any*/)
                        ]
                      },
                      (v23/*: any*/),
                      (v24/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "699be9b81fc7f2d8a2bc6b02126e9e7f",
    "id": "bacba6f59f512b80b185bd9f1146c403ef66211c7d7ea7aa288d0cd5991e41cf",
    "metadata": {},
    "name": "useBlogPostsQueryQuery",
    "operationKind": "query",
    "text": "query useBlogPostsQueryQuery($cql:String!,$first:Int,$includeRenderedBody:Boolean!,$includeAdfBody:Boolean!,$includeExcerpt:Boolean!,$includeRenderedExcerpt:Boolean!,$includeAdfExcerpt:Boolean!){search:confluence_search(cql:$cql,first:$first){count,nodes{content{id,title,type,excerpt(length:500)@include(if:$includeExcerpt)\n        macroExcerpt@include(if:$includeExcerpt){view(fallbackToBody:false)@include(if:$includeRenderedExcerpt),atlasDocFormat(fallbackToBody:false)@include(if:$includeAdfExcerpt)},body{view@include(if:$includeRenderedBody){value},atlas_doc_format@include(if:$includeAdfBody){value}},labels{nodes{name,id}},links{webui,base},space{id,key,name},history{createdBy{__typename,...on KnownUser{accountId,displayName,profilePicture{path}},...on UnknownUser{displayName,profilePicture{path}}},createdDate,lastUpdated{when}}}}}}"
  }
};
})();

(node as any).hash = "3f280e1c95f5ec8caddd8aa0f842d89a";

export default node;
